import config from '../config';
import axios from 'axios';

const otpBaseURL = config.NODE_API_BASE_URL + '/wso2/otp';

const sendOtp = async (email, purpose = 'email_verification') => {
    try {
        const response = await axios.post(`${otpBaseURL}/send`, { email, purpose });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response?.data) {
            return error.response.data;
        }
        throw error;
    }
};

const resendOtp = async (email, purpose = 'email_verification') => {
    try {
        const response = await axios.post(`${otpBaseURL}/resend`, { email, purpose });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response?.data) {
            return error.response.data;
        }
        throw error;
    }
};

const verifyOtp = async (email, otp, purpose = 'email_verification') => {
    try {
        const response = await axios.post(`${otpBaseURL}/verify`, { email, otp, purpose });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response?.data) {
            return error.response.data;
        }
        throw error;
    }
};

const verifyOtpAndCreateProfile = async (payload) => {
    try {
        const response = await axios.post(`${config.NODE_API_BASE_URL}/wso2/verifyOTP_profile`, payload);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response?.data) {
            return error.response.data;
        }
        throw error;
    }
};

export { sendOtp, resendOtp, verifyOtp, verifyOtpAndCreateProfile };
